export enum ActivityType {
  FiveYearInspection = 10,
  SixMonthsInspection = 20,
  Tomning = 30,
  Fritext = 40,
  WaterMeasurementProtocol = 50,
  Other = 100,
  Undefined = 0,
}

export const getActivityTypeName = (activityType: ActivityType) => {
  switch (activityType) {
    case ActivityType.FiveYearInspection:
      return "5-årsbesiktning";
    case ActivityType.SixMonthsInspection:
      return "6-månaderskontroll";
    case ActivityType.Tomning:
      return "Avfallstransport";
    case ActivityType.Other:
      return "Övrigt";
    case ActivityType.WaterMeasurementProtocol:
      return "Vattenprovtagning";
    default:
      throw Error(
        `getAssignmentTypeName saknar implementation för ${activityType}`,
      );
  }
};

export const activityTypeNameShort = (type: ActivityType) => {
  switch (type) {
    case ActivityType.FiveYearInspection:
      return "5års";
    case ActivityType.SixMonthsInspection:
      return "6mån";
    case ActivityType.Tomning:
      return "Tömning";
    case ActivityType.WaterMeasurementProtocol:
      return "Provtagning";
    default:
      throw Error("Invalid AssignmentType : " + type);
  }
};
